import { render } from "./HeroiconsSolidMail.vue?vue&type=template&id=0d4cdb38"
const script = {}

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidMail.vue"]])

export default __exports__